(function () {
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    // compensate for scrollbar removal
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.paddingRight = scrollbarWidth ? `${scrollbarWidth}px` : '';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';

    window.scrollTo(0, scrollY);
  }

  function openDrawer(drawer, trigger) {
    drawer.classList.add('drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    lockScroll();
  }

  function closeDrawer(drawer, trigger) {
    drawer.classList.remove('drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    unlockScroll();
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-benefit-trigger]');
    if (trigger) {
      e.preventDefault();
      const id = trigger.getAttribute('data-benefit-id');
      const drawer = document.querySelector(`[data-benefit-drawer][data-benefit-id="${id}"]`);
      if (!drawer) return;

      // close any other open
      document.querySelectorAll('[data-benefit-drawer].drawer--open').forEach(d => {
        const did = d.getAttribute('data-benefit-id');
        const t = document.querySelector(`[data-benefit-trigger][data-benefit-id="${did}"]`);
        closeDrawer(d, t);
      });

      openDrawer(drawer, trigger);
      return;
    }

    const overlay = e.target.closest('[data-drawer-overlay]');
    if (overlay) {
      const drawer = overlay.closest('[data-benefit-drawer]');
      if (!drawer) return;
      const id = drawer.getAttribute('data-benefit-id');
      const t = document.querySelector(`[data-benefit-trigger][data-benefit-id="${id}"]`);
      closeDrawer(drawer, t);
      return;
    }

    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('[data-benefit-drawer]');
      if (!drawer) return;
      const id = drawer.getAttribute('data-benefit-id');
      const t = document.querySelector(`[data-benefit-trigger][data-benefit-id="${id}"]`);
      closeDrawer(drawer, t);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-benefit-drawer].drawer--open').forEach(drawer => {
      const id = drawer.getAttribute('data-benefit-id');
      const t = document.querySelector(`[data-benefit-trigger][data-benefit-id="${id}"]`);
      closeDrawer(drawer, t);
    });
  });
})();
